import { forwardRef } from 'react';
import './PrimaryActionButton.css';

const PrimaryActionButton = forwardRef(function PrimaryActionButton(
    { children, className = '', type = 'button', ...buttonProps },
    ref,
) {
    return (
        <button
            ref={ref}
            type={type}
            className={`primaryActionButton ${className}`.trim()}
            {...buttonProps}
        >
            {children}
        </button>
    );
});

export default PrimaryActionButton;
